// SSE(text/event-stream) 파서 — 순수 함수. 청크 경계는 어디서 잘려도 같은 이벤트가 나온다.
// 규칙은 MVP API 의 대화 중계(api/internal/httpapi/llm.go)가 내보내는 것만 다룬다: `event:` · `data:` 줄, 빈 줄로 끝, `:` 로 시작하는 주석

export interface RawEvent {
  readonly name: string;
  /** data 줄을 개행으로 이은 값. 중계는 JSON 한 줄을 보낸다 */
  readonly data: string;
}

export interface SseParser {
  /** 청크를 먹이면 그 청크로 끝맺은 이벤트를 순서대로 돌려준다. 빈 줄로 끝맺지 못한 조각은 다음 청크까지 들고 있는다 */
  feed(chunk: string): RawEvent[];
}

function parseBlock(block: string): RawEvent | null {
  let name = '';
  const data: string[] = [];
  for (const line of block.split('\n')) {
    if (line === '' || line.startsWith(':')) continue;
    const at = line.indexOf(':');
    const field = at < 0 ? line : line.slice(0, at);
    const value = at < 0 ? '' : line.slice(at + 1).replace(/^ /, '');
    if (field === 'event') name = value;
    else if (field === 'data') data.push(value);
  }
  if (name === '' && data.length === 0) return null;
  return { name: name || 'message', data: data.join('\n') };
}

export function createSseParser(): SseParser {
  let buffer = '';
  return {
    feed(chunk) {
      let text = (buffer + chunk).replace(/\r\n/g, '\n');
      // 청크가 \r 에서 끊기면 다음 청크의 \n 과 한 쌍일 수 있다 — 한 줄바꿈으로 읽지 않고 남겨 둔다
      const pending = text.endsWith('\r') ? '\r' : '';
      if (pending) text = text.slice(0, -1);
      const blocks = text.replace(/\r/g, '\n').split('\n\n');
      buffer = (blocks.pop() ?? '') + pending;
      const events: RawEvent[] = [];
      for (const block of blocks) {
        const event = parseBlock(block);
        if (event) events.push(event);
      }
      return events;
    },
  };
}
